import { z } from 'zod';
import { apiEnvelope } from '../envelope';
import { pushPermissionReportedDataSchema, pushPlatformSchema } from '../push/schema';

// Staff view of a member's push reachability: the latest reported permission
// per platform, and a token-free summary of the registered devices. Served by
// its own route rather than folded into the member read, which deployed Atlas
// bundles parse as-is (ADR-135 Rule 4). Non-strict: client-parsed.

export const memberPushPermissionEntrySchema = pushPermissionReportedDataSchema;
export type MemberPushPermissionEntry = z.infer<typeof memberPushPermissionEntrySchema>;

// Only the platform, whether a push token is on file, and the row's own
// timestamps: never a token, a provider, or the row id, so a widened reader
// still cannot reach a device credential. `hasPushToken` is false for a
// VoIP-only registration, which can ring calls but cannot deliver a
// notification.
export const memberPushDeviceEntrySchema = z.object({
  platform: pushPlatformSchema,
  hasPushToken: z.boolean(),
  registeredAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type MemberPushDeviceEntry = z.infer<typeof memberPushDeviceEntrySchema>;

export const memberPushStatusDataSchema = z.object({
  permissions: z.array(memberPushPermissionEntrySchema),
  devices: z.array(memberPushDeviceEntrySchema),
});
export type MemberPushStatusData = z.infer<typeof memberPushStatusDataSchema>;

export const memberPushStatusResponseSchema = apiEnvelope(memberPushStatusDataSchema);
export type MemberPushStatusResponse = z.infer<typeof memberPushStatusResponseSchema>;
